$(document).on('click', '.survey-wrapper .radio-li', function () {

    let chosenVal = parseInt($(this).attr('name'))
    if (chosenVal) {
        $(`input[value="${chosenVal}"]`).prop('checked', true);

        $('img.filled-rating').removeClass('opacity-full');
        $(this).find('img.filled-rating').addClass('opacity-full');

        $('.survey-wrapper .hs-form').slideDown(400);

        let ph;
        switch (chosenVal) {
            case 1:
                ph = "What went wrong, and how can we improve?";
                break;

            case 2:
                ph = "What didn't meet your expectations?";
                break;

            case 3:
                ph = "What could we have done to make your experience better?";
                break;
        
            case 4:
                ph = "What did you like most about your experience?";
                break;

            case 5:
                ph = "What made your experience so great?";
                break;
        
            default:
                ph = "How was your experience?";
                break;
        }

        $(".survey-wrapper .hs-form textarea").attr('placeholder', ph);

    }

})

$(document).on('submit', '.survey-wrapper .hs-form', function () {
    $(`input[name*="tsdc_company"]`).val("BD");
    $('.survey-header, .survey-container, .survey-wrapper .hs-form, .survey-header-wrapper').hide();
    $('.thanks-for-submitting').show();
});